/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Onh_PInputs */

const en_wc_onh_p = /** @type {(inputs: Wc_Onh_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the editor at the top of this page to create a document or open a copy of a local file. Try formatting a paragraph, applying a heading style and inserting a table. Save your work to your device before closing the page. Nothing needs to be installed, and no site account is required. The online guide covers browser requirements, fonts and saving files.`)
};

/**
* | output |
* | --- |
* | "Use the editor at the top of this page to create a document or open a copy of a local file. Try formatting a paragraph, applying a heading style and insertin..." |
*
* @param {Wc_Onh_PInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_onh_p = /** @type {((inputs?: Wc_Onh_PInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Onh_PInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_onh_p(inputs)
});
export { wc_onh_p as "wc.onh.p" }